<template>
  <v-snackbar 
    :color="snackBarType"
    multi-line
    :timeout='timeout'
    v-model="snackBarshow">
    {{snackBarmessage}}
    <v-btn text  @click="snackBarshow = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
  data () {
    return {
      timeout : 6000,
    }
  },
      computed : {
    ...mapFields([
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
}
}
</script>